<template>
  <div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <button type="button" @click="abrirModalPaquete('Agregar', equipo.id)" class="btn btn-primary btn-sm"
            data-toggle="modal" data-target="#Modal_paquetes" v-if="$store.getters.can('admin.equipos.asignPaquetes')">
            <i class="far fa-folder"></i> Paquetes
          </button>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col-md-12" v-for="paquete in equipo.paquetes" :key="paquete.id">
          <div class="card card-warning card-outline">
            <div class="card-header pt-2 pb-2">
              <h3 class="card-title">
                <i class="far fa-folder"></i>
                {{ paquete.nombre }}
              </h3>
              <div class="card-tools">
                <button type="button" class="btn btn-tool" data-card-widget="collapse" data-toggle="tooltip"
                  title="Collapse">
                  <i class="fas fa-minus"></i>
                </button>
              </div>
            </div>
            <div class="card-body" style="display: block">
              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6 mb-3" v-for="documento in paquete.documentos"
                  :key="documento.id">
                  <div class="card card-outline h-100" :class="getDocumentCardClass(documento)">
                    <div class="card-header">
                      <h6 class="card-title mb-0">
                        <i class="fas fa-file-alt me-1"></i>
                        {{ documento.descripcion }}
                      </h6>
                    </div>
                    <div class="card-body">
                      <div class="d-flex justify-content-between align-items-start mb-2">
                        <span v-if="validaDoc(equipo.documentos_files, documento, 2)" class="badge bg-success">
                          <i class="fas fa-check me-1"></i>
                          Cargado
                        </span>
                        <span v-else-if="documento.pivot.relevante" class="badge bg-danger">
                          <i class="fas fa-exclamation-triangle me-1"></i>
                          Requerido
                        </span>
                        <span v-else class="badge bg-secondary">
                          <i class="fas fa-info me-1"></i>
                          Opcional
                        </span>
                        <span v-if="getMotivoRechazo(documento)" class="badge bg-danger ml-1"
                          title="Documento rechazado">
                          <i class="fas fa-ban me-1"></i>
                          Rechazado
                        </span>
                      </div>

                      <div v-if="getMotivoRechazo(documento)" class="alert alert-danger py-2 px-2 mb-2" role="alert">
                        <small class="d-block fw-bold mb-1">
                          <i class="fas fa-ban me-1"></i> Motivo de rechazo
                        </small>
                        <small class="d-block" style="white-space: pre-wrap">
                          {{ getMotivoRechazo(documento) }}
                        </small>
                      </div>

                      <!-- Información del documento -->
                      <div v-if="validaDoc(equipo.documentos_files, documento, 1)" class="mb-3">
                        <div class="row">
                          <div class="col-6">
                            <small class="text-muted">Referencia:</small>
                            <p class="mb-1 fw-bold">{{
                              equipo.documentos_files.find(
                                (file) => file.documento_id === documento.id
                              ).referencia
                            }}</p>
                          </div>
                          <div class="col-6">
                            <small class="text-muted">Emisor:</small>
                            <p class="mb-1">{{
                              equipo.documentos_files.find(
                                (file) => file.documento_id === documento.id
                              ).emisor
                            }}</p>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-6">
                            <small class="text-muted">Fecha Emisión:</small>
                            <p class="mb-1">{{
                              equipo.documentos_files.find(
                                (file) => file.documento_id === documento.id
                              ).fecha_emision
                            }}</p>
                          </div>
                          <div class="col-6">
                            <small class="text-muted">Fecha Vencimiento:</small>
                            <p class="mb-1" :class="isFechaVencida(equipo.documentos_files.find(
                              (file) => file.documento_id === documento.id
                            ).fecha_vencimiento) ? 'text-danger fw-bold' : 'text-success fw-bold'">{{
                              equipo.documentos_files.find(
                                (file) => file.documento_id === documento.id
                              ).fecha_vencimiento
                            }}</p>
                          </div>
                        </div>

                        <!-- Previsualizador de Google -->
                        <div class="mt-3">
                          <iframe :src="getGooglePreviewUrl(equipo.documentos_files.find(
                            (file) => file.documento_id === documento.id
                          ).link)" width="100%" height="200" frameborder="0" class="rounded"></iframe>
                        </div>
                      </div>

                      <!-- Estado cuando no hay documento -->
                      <div v-else class="text-center py-3">
                        <i class="fas fa-file-upload text-muted mb-2" style="font-size: 2rem;"></i>
                        <p class="text-muted mb-0">Documento no cargado</p>
                      </div>
                    </div>

                    <div class="card-footer bg-transparent">
                      <div class="d-flex justify-content-between align-items-center">
                        <!-- Switch de verificación -->
                        <div v-if="validaDoc(equipo.documentos_files, documento, 2) &&
                          $store.getters.can('admin.equipos.checkDoc')">
                          <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox"
                              :id="'customSwitch' + paquete.id + '-' + documento.id"
                              :class="'customSwitch' + documento.id"
                              v-model="btnVerificado[paquete.id + '-' + documento.id]"
                              :disabled="loadingVerification[paquete.id + '-' + documento.id]"
                              v-if="$store.getters.can('admin.equipos.verificarDocumento')" @change="verificarDoc(
                                documento.id,
                                equipo.documentos_files.find(
                                  (file) => file.documento_id === documento.id
                                ).id,
                                paquete.id
                              )" />
                            <label class="form-check-label" :for="'customSwitch' + paquete.id + '-' + documento.id">
                              <span v-if="!loadingVerification[paquete.id + '-' + documento.id]">
                                <i v-if="btnVerificado[paquete.id + '-' + documento.id]"
                                  class="fas fa-check-circle me-1 text-success"></i>
                                <i v-else class="fas fa-times-circle me-1 text-danger"></i>
                                <span v-if="btnVerificado[paquete.id + '-' + documento.id]" class="text-success">
                                  Verificado
                                </span>
                                <span v-else class="text-danger">
                                  Pendiente por verificar
                                </span>
                              </span>
                              <span v-else class="text-muted">
                                <div class="spinner-border spinner-border-sm me-1" role="status">
                                  <span class="sr-only">Cargando...</span>
                                </div>
                                Verificando...
                              </span>
                            </label>
                          </div>
                        </div>

                        <!-- Botones de acción -->
                        <div class="btn-group btn-group-sm">
                          <!-- Botón subir documento -->
                          <button type="button" class="btn btn-info"
                            :disabled="validaDoc(equipo.documentos_files, documento, 2)" data-toggle="modal"
                            data-target="#Modal_docs" @click="abrirModalDoc('Agregar', documento)"
                            v-if="$store.getters.can('admin.equipos.documentosEdit')" title="Subir documento">
                            <i class="fas fa-upload"></i>
                          </button>

                          <!-- Botón descargar -->
                          <a v-if="validaDoc(equipo.documentos_files, documento, 2)" target="_blank"
                            class="btn btn-primary" :href="uri_docs + equipo.documentos_files.find(
                              (file) => file.documento_id === documento.id
                            ).link" title="Descargar documento">
                            <i class="fas fa-download"></i>
                          </a>

                          <!-- Botón previsualizar -->
                          <button v-if="validaDoc(equipo.documentos_files, documento, 2)" type="button"
                            class="btn btn-success" data-toggle="modal" data-target="#Modal_preview" @click="openPreviewModal(equipo.documentos_files.find(
                              (file) => file.documento_id === documento.id
                            ).link)" title="Previsualizar documento">
                            <i class="fas fa-eye"></i>
                          </button>

                          <!-- Botón rechazar documento -->
                          <button v-if="validaDoc(equipo.documentos_files, documento, 2) &&
                            $store.getters.can('admin.equipos.rechazarDocumento')" type="button" class="btn btn-warning"
                            data-toggle="modal" data-target="#Modal_rechazo" @click="abrirModalRechazo(
                              equipo.documentos_files.find(
                                (file) => file.documento_id === documento.id
                              ),
                              documento
                            )" title="Rechazar documento">
                            <i class="fas fa-ban"></i>
                          </button>

                          <!-- Botón eliminar -->
                          <button type="button" class="btn btn-danger" v-if="validaDoc(equipo.documentos_files, documento, 1) &&
                            $store.getters.can('admin.equipos.documentosEdit')" @click="eliminarDoc(equipo.documentos_files.find(
                                    (file) => file.documento_id === documento.id
                                  ).id)" title="Eliminar documento">
                            <i class="fas fa-trash-alt"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL PAQUETES -->
    <div class="modal fade" id="Modal_paquetes" v-if="$store.getters.can('admin.equipos.asignPaquetes')">
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">{{ modal.title }}</h4>
            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" ref="closeModal"
              id="close-modal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-lg-11">
                <div class="form-group">
                  <label for="paquete">Paquete</label>
                  <v-select :class="$store.getters.getDarkMode ? 'dark-vselect' : ''" v-model="formPaquete.listPaquetes"
                    label="nombre" :options="listPaquetes" placeholder="Paquetes"
                    @input="getSelectPaquete()"></v-select>
                </div>
              </div>
              <div class="col-md-1">
                <button type="button" class="btn btn-primary mt-4" @click="savePaquete(true, null)">
                  <i class="fas fa-save"></i>
                </button>
              </div>
            </div>
            <hr />
            <div class="row">
              <table class="table table-stripped table-hover table-bordered table-sm">
                <thead>
                  <tr>
                    <th>Paquete</th>
                    <th>Eliminar</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="paquete in equipo.paquetes" :key="paquete.id">
                    <td v-text="paquete.nombre"></td>
                    <td>
                      <button type="button" class="btn btn-sm btn-danger" @click="savePaquete(false, paquete.id)">
                        <i class="fas fa-trash-alt"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer justify-content-between"></div>
        </div>
      </div>
    </div>

    <!-- MODAL DOCUMENTOS -->
    <div class="modal fade" id="Modal_docs">
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">{{ modal.title }}</h4>
            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" ref="closeModal"
              id="close-modal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-lg-12">
                <div class="form-group">
                  <label for="descripcion">Descripción</label>
                  <input type="text" class="form-control form-control-sm" id="descripcion" placeholder="descripcion"
                    v-model="formDoc.descripcion" :class="$v.formDoc.descripcion.$invalid
                        ? 'is-invalid'
                        : 'is-valid'
                      " readonly />
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="referencia">Referencia</label>
                  <input type="text" class="form-control form-control-sm" id="referencia" placeholder="Referencia"
                    v-model="formDoc.referencia" :class="$v.formDoc.referencia.$invalid ? 'is-invalid' : 'is-valid'
                      " />
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="emisor">Emisor</label>
                  <input type="text" class="form-control form-control-sm" id="emisor" placeholder="Emisor"
                    v-model="formDoc.emisor" :class="$v.formDoc.emisor.$invalid ? 'is-invalid' : 'is-valid'
                      " />
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="fecha_emision">Fecha Emisión</label>
                  <input type="date" class="form-control form-control-sm" id="fecha_emision" placeholder="Fecha Emisión"
                    v-model="formDoc.fecha_emision" :class="$v.formDoc.fecha_emision.$invalid
                        ? 'is-invalid'
                        : 'is-valid'
                      " />
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12" v-if="formDoc.vencimiento">
                <div class="form-group">
                  <label for="fecha_vencimiento">Fecha Vencimiento</label>
                  <input type="date" class="form-control form-control-sm" id="fecha_vencimiento"
                    placeholder="Fecha Emisión" v-model="formDoc.fecha_vencimiento" :class="$v.formDoc.fecha_vencimiento.$invalid
                        ? 'is-invalid'
                        : 'is-valid'
                      " />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <input type="file" class="form-control-file" ref="file" id="btnFile" @change="getFile"
                  accept="application/msword,application/pdf,application/rtf,image/*" />
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-primary" @click="saveDoc()">
              Guardar
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <!-- MODAL PREVIEW -->
    <div class="modal fade" id="Modal_preview" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h5 class="modal-title">
              <i class="fas fa-eye me-2"></i>
              Previsualización del Documento
            </h5>
            <button type="button" class="close text-white" data-dismiss="modal">
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body p-0">
            <iframe :src="previewUrl" width="100%" height="600" frameborder="0"
              style="border-radius: 0 0 0.375rem 0.375rem;"></iframe>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL RECHAZO -->
    <div class="modal fade" id="Modal_rechazo" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header bg-danger text-white pt-2 pb-2">
            <h5 class="modal-title">
              <i class="fas fa-ban me-2"></i>
              Rechazar documento
            </h5>
            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close"
              ref="closeModalRechazo">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="mb-2">
              Va a rechazar el documento
              <b>{{ formRechazo.descripcion }}</b>. Indique el motivo del
              rechazo. Se enviará una notificación por correo a la lista de
              distribución de la empresa transportadora.
            </p>
            <div class="form-group">
              <label for="motivo_rechazo">Motivo del rechazo *</label>
              <textarea id="motivo_rechazo" class="form-control form-control-sm" rows="4" maxlength="1000"
                v-model="formRechazo.motivo_rechazo" :class="!formRechazo.motivo_rechazo ||
                  formRechazo.motivo_rechazo.trim().length < 3
                  ? 'is-invalid'
                  : 'is-valid'
                  " placeholder="Describa la razón por la cual se rechaza el documento"></textarea>
              <small class="text-muted">
                Mínimo 3 caracteres, máximo 1000.
              </small>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Cancelar
            </button>
            <button type="button" class="btn btn-danger" :disabled="!formRechazo.motivo_rechazo ||
              formRechazo.motivo_rechazo.trim().length < 3 ||
              loadingRechazo
              " @click="rechazarDoc()">
              <span v-if="!loadingRechazo">
                <i class="fas fa-ban me-1"></i> Confirmar rechazo
              </span>
              <span v-else>
                <i class="fas fa-spinner fa-spin me-1"></i> Procesando...
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required, minLength } from "vuelidate/lib/validators";
import vSelect from "vue-select";

export default {
  name: "EquipoDocumento",
  components: {
    vSelect,
  },
  data() {
    return {
      cargando: false,
      equipo: [],
      formDoc: {},
      formPaquete: {},
      listPaquetes: [],
      btnVerificado: {},
      modal: {
        title: "",
        accion: "",
      },
      fileDoc: null,
      uri_docs: process.env.VUE_APP_AWS_BUCKET_URL,
      previewUrl: "",
      loadingVerification: {},
      formRechazo: {
        documento_archivo_id: null,
        documento_id: null,
        descripcion: "",
        motivo_rechazo: "",
      },
      loadingRechazo: false,
    };
  },
  validations() {
    if (this.formDoc.vencimiento) {
      return {
        formDoc: {
          descripcion: {
            required,
          },
          referencia: {
            required,
          },
          emisor: {
            required,
          },
          fecha_emision: {
            required,
          },
          fecha_vencimiento: {
            required,
          },
        },
        formPaquete: {
          paquete_id: {
            required,
          },
        },
      };
    } else {
      return {
        formDoc: {
          descripcion: {
            required,
          },
          referencia: {
            required,
          },
          emisor: {
            required,
          },
          fecha_emision: {
            required,
          },
        },
        formPaquete: {
          paquete_id: {
            required,
          },
        },
      };
    }
  },
  methods: {
    getPaquetes() {
      axios.get("/api/admin/paquetes/lista").then((response) => {
        this.listPaquetes = response.data;
      });
    },

    getSelectPaquete() {
      this.formPaquete.paquete_id = this.formPaquete.listPaquetes.id;
    },

    getEquipo(id) {
      axios.get("/api/admin/equipos/" + id).then((response) => {
        this.equipo = response.data[0];
        this.getVerificado();
      });
    },

    abrirModalPaquete(accion, id) {
      this.modal.accion = accion;
      this.modal.title = accion + " Paquete";
      this.formPaquete.equipo_id = id;
    },

    validaDoc(files, documento, tipo) {
      if (
        files.find((file) => file.documento_id === documento.id) !== undefined
      ) {
        if (tipo == 2) {
          if (
            files.find((file) => file.documento_id === documento.id).link !== ""
          ) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      } else {
        return false;
      }
    },

    savePaquete(accion, id) {
      if (id != null) {
        this.formPaquete.paquete_id = id;
      }

      this.formPaquete.equipo_id = this.equipo.id;
      this.formPaquete.accion = accion;
      if (!this.$v.formPaquete.$invalid) {
        this.$parent.cargando = true;
        axios({
          method: "PUT",
          url: "/api/admin/equipos/assignOrRevokePaquetesDocumentos",
          data: this.formPaquete,
        })
          .then(() => {
            this.getEquipo(this.$parent.form.id);
            this.$refs.closeModal.click();
            this.formPaquete = {};
            this.$swal({
              icon: "success",
              title: "Se guardo exitosamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
            });
            this.$parent.cargando = false;
          })
          .catch((e) => {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error, vuelva a intentarlo..." + e,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
            });
            this.$parent.cargando = false;
          });
      }
    },

    abrirModalDoc(accion, documento) {
      this.modal.accion = accion;
      this.modal.title = accion + " Documento";
      this.formDoc = {
        entidad_id: this.$parent.form.id,
        documento_id: documento.id,
        descripcion: documento.descripcion,
        vencimiento: documento.vencimiento,
      };
    },

    getFile(e) {
      if (e.target.files[0]) {
        const file = e.target.files[0];
        if (this.validaArchivo(file)) {
          this.fileDoc = file;
        }
      }
    },

    validaArchivo(file) {
      let flag = true;
      if (file.size > 2048000) {
        flag = false;
        let inputImage = document.getElementById("btnFile");
        inputImage.value = "";
        this.$swal({
          icon: "error",
          title: `El Archivo es muy pesado para subirlo`,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      }
      return flag;
    },

    saveDoc() {
      if (!this.$v.formDoc.$invalid) {
        this.$parent.cargando = true;
        let formData = new FormData();
        formData.append("entidad_id", this.formDoc.entidad_id);
        formData.append("entidad", "Equipo");
        formData.append("documento_id", this.formDoc.documento_id);
        formData.append("descripcion", this.formDoc.descripcion);

        formData.append("referencia", this.formDoc.referencia);
        formData.append("emisor", this.formDoc.emisor);
        formData.append("fecha_emision", this.formDoc.fecha_emision);
        formData.append("fecha_vencimiento", this.formDoc.fecha_vencimiento);
        formData.append("file", this.fileDoc);

        axios
          .post("/api/admin/equipos/documentos", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            if (res.data.msg) {
              this.$swal({
                icon: "error",
                title: res.data.msg,
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 4000,
                timerProgressBar: true,
              });
            } else {
              this.getEquipo(this.$parent.form.id);
              this.$refs.closeModal.click();
              this.formDoc = {};
              this.$swal({
                icon: "success",
                title: "Se guardo exitosamente...",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 4000,
                timerProgressBar: true,
              });
            }
            this.$parent.cargando = false;
          })
          .catch((e) => {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error, vuelva a intentarlo..." + e,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
            });
            this.$parent.cargando = false;
          });
      } else {
        this.$swal({
          icon: "error",
          title: "Ocurrio un error, vuelva a intentarlo...",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
        });
      }
    },

    eliminarDoc(idDoc) {
      this.$swal({
        title: "Esta seguro de eliminar esta Documento?",
        text: "Los cambios no se pueden revertir!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Eliminar!",
      }).then((result) => {
        if (result.value) {
          let datos = {
            entidad_id: this.$parent.form.id,
            entidad: "Equipo",
          };
          axios({
            method: "DELETE",
            url: "/api/admin/equipos/documentos/" + idDoc,
            data: datos,
          }).then(() => {
            this.getEquipo(this.$parent.form.id);
            this.$swal({
              icon: "success",
              title: "Se elimino la Documento exitosamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
            });
          });
        }
      });
    },

    verificarDoc(documentoId, documentoFilId, paqueteId) {
      const key = paqueteId + "-" + documentoId;

      // Activar estado de carga
      this.$set(this.loadingVerification, key, true);

      let data = {
        verificado: this.btnVerificado[key] ? 1 : 0,
      };

      axios({
        method: "PUT",
        url: "/api/admin/equipos/checkDoc/" + documentoFilId,
        data: data,
      }).then(() => {
        // Desactivar estado de carga
        this.$set(this.loadingVerification, key, false);

        this.$swal({
          icon: "success",
          title: "Documento verificado...",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
        });
      }).catch((error) => {
        // Desactivar estado de carga en caso de error
        this.$set(this.loadingVerification, key, false);

        // Revertir el estado del checkbox
        this.$set(this.btnVerificado, key, !this.btnVerificado[key]);

        this.$swal({
          icon: "error",
          title: "Error al verificar documento",
          text: "Intente nuevamente",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
        });
      });
    },

    getVerificado() {
      for (let i = 0; i < this.equipo.paquetes.length; i++) {
        const paquete = this.equipo.paquetes[i];
        for (let j = 0; j < paquete.documentos.length; j++) {
          const documento = paquete.documentos[j];
          let verif = this.equipo.documentos_files.find(
            (file) => file.documento_id === documento.id
          );

          if (verif !== undefined) {
            this.btnVerificado[
              paquete.id + "-" + documento.id
            ] = this.equipo.documentos_files.find(
              (file) => file.documento_id === documento.id
            ).verificado;
          } else {
            this.btnVerificado[paquete.id + "-" + documento.id] = false;
          }
        }
      }
    },

    getDocumentCardClass(documento) {
      if (this.validaDoc(this.equipo.documentos_files, documento, 2)) {
        return 'card-success';
      } else if (documento.pivot.relevante) {
        return 'card-danger';
      } else {
        return 'card-secondary';
      }
    },

    getGooglePreviewUrl(fileLink) {
      if (!fileLink) return '';
      const fullUrl = this.uri_docs + fileLink;
      return `https://docs.google.com/gview?url=${encodeURIComponent(fullUrl)}&embedded=true`;
    },

    openPreviewModal(fileLink) {
      this.previewUrl = this.getGooglePreviewUrl(fileLink);

    },

    isFechaVencida(fechaVencimiento) {
      if (!fechaVencimiento) return false;
      const hoy = new Date();
      const fechaVenc = new Date(fechaVencimiento);
      return fechaVenc < hoy;
    },

    getMotivoRechazo(documento) {
      const archivo = (this.equipo.documentos_files || []).find(
        (file) => file.documento_id === documento.id
      );
      if (!archivo) return null;
      const motivo = archivo.motivo_rechazo;
      if (motivo && String(motivo).trim() !== "" && !archivo.verificado) {
        return motivo;
      }
      return null;
    },

    abrirModalRechazo(documentoFile, documento) {
      this.formRechazo = {
        documento_archivo_id: documentoFile ? documentoFile.id : null,
        documento_id: documento ? documento.id : null,
        descripcion: documento ? documento.descripcion : "",
        motivo_rechazo: "",
      };
    },

    rechazarDoc() {
      if (
        !this.formRechazo.documento_archivo_id ||
        !this.formRechazo.motivo_rechazo ||
        this.formRechazo.motivo_rechazo.trim().length < 3
      ) {
        this.$swal({
          icon: "error",
          title: "Debe indicar un motivo de rechazo (mín. 3 caracteres).",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
        });
        return;
      }

      this.loadingRechazo = true;

      axios({
        method: "PUT",
        url:
          "/api/admin/equipos/rejectDoc/" +
          this.formRechazo.documento_archivo_id,
        data: {
          motivo_rechazo: this.formRechazo.motivo_rechazo.trim(),
        },
      })
        .then(() => {
          this.loadingRechazo = false;
          this.$refs.closeModalRechazo.click();
          this.getEquipo(this.$parent.form.id);
          this.$swal({
            icon: "success",
            title: "Documento rechazado y notificación enviada.",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
        })
        .catch((error) => {
          this.loadingRechazo = false;
          this.$swal({
            icon: "error",
            title: "Error al rechazar el documento",
            text:
              error.response?.data?.errors?.motivo_rechazo?.[0] ||
              error.response?.data?.msg ||
              "Intente nuevamente",
          });
        });
    },
  },
  mounted() {
    this.getPaquetes();
    this.getEquipo(this.$parent.form.id);
  },
};
</script>
